import { 
    ACTUALIZAR_LIST_NIVEL3,
    AGREGAR_NIVEL3,
    MODIFICAR_NIVEL3,
  } from "./nivel3Actions";

  const prcesoReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_NIVEL3: {
            return {
                ...state,
                nivel3List: action.payload
            }
        };

        case AGREGAR_NIVEL3:{
            return {
                 ...state,
                 nivel3List: [action.payload, ...state.nivel3List]
             }
         };

        case MODIFICAR_NIVEL3: {
            return {
                ...state,
                nivel3List: state.nivel3List.map((g) => g._id === action.payload._id ? action.payload : g)
            }
        };

        default:
            return state;

    }
  }

  export default prcesoReducer;